export enum UsersSearchActionTypes {
  INITIALIZED = 'users-search/INITIALIZED',
  FETCHING = 'users-search/FETCHING',
  RECEIVED = 'users-search/RECEIVED',
  RESET = 'users-search/RESET',
}
